export default __webpack_public_path__ + "static/JakubGerula-90537231a78c01d06811ff7f2c80fbb2.png";